'use strict';
exports.__esModule = true;
var smartorg_1 = require("../../../../../lib/smartorg-api/smartorg");
angular.module('smartorg.r6.views.firstpage', [
    'ngRoute',
    require('../../../../../components/password/app/js/plumbing/app.js'),
    require('../../../../../widgets/management/legal-message/app/js/plumbing/app')
]).config(['$routeProvider', function ($routeProvider) {
        $routeProvider.when('/firstpage', {
            template: require('../../template/firstpage.html'),
            controller: 'FirstPageCtrl'
        });
    }]).controller('FirstPageCtrl', ['$scope', '$location', '$timeout', 'config',
    function ($scope, $location, $timeout, config) {
        var smartorgApi = config.smartorg;
        $scope.flow = {
            /**
             * That means user have not accepted license yet.
             */
            needValidation: false,
            current: 0,
            /**
             * False means not need to display
             */
            states: {
                license: false,
                warning: false,
                profile: false,
                password: false,
                browser: false
            }
        };
        $scope.loaded = {
            profile: false,
            license: false,
            warning: false
        };
        $scope.ignoreBrowser = false;
        /**
         * Load license info.
         */
        $scope.loadLicenseInfo = function () {
            smartorgApi.getWelcomeMessage('LICENSE').then(function (rs) {
                if (rs['status'] === 0) {
                    var state = rs.data.config.state;
                    // show if license NOT accepted (first login users won't have licence accepted)
                    // or on every login
                    if (((state == true || state == 1) &&
                        $scope.flow.needValidation) || state == 2) {
                        $scope.flow.states.license = true;
                        $scope.$broadcast('manage:LEGAL_DISPLAY', {
                            messageType: 'LICENSE',
                            message: rs.data.config.message
                        });
                    }
                    else {
                        // security warning
                        $scope.loadSecurityWarning();
                    }
                }
                else {
                    // security warning
                    $scope.loadSecurityWarning();
                }
                $scope.loaded.license = true;
                $timeout();
            })["catch"](function (err) {
                console.log('danger', "Error " + err.status, err);
            });
        };
        /**
         * Load security warnings.
         */
        $scope.loadSecurityWarning = function () {
            smartorgApi.getWelcomeMessage('SECURITY_WARNING_WB').then(function (rs) {
                if (rs['status'] === 0) {
                    var state = rs.data.config.state;
                    // show on first login or every login
                    if (((state == true || state == 1) &&
                        $scope.flow.needValidation) || state == 2) {
                        $scope.flow.states.warning = true;
                        $scope.$broadcast('manage:LEGAL_DISPLAY', {
                            messageType: 'SECURITY_WARNING_WB',
                            message: rs.data.config.message
                        });
                    }
                }
                $scope.loaded.warning = true;
                $timeout();
                $scope.check();
            })["catch"](function (err) {
                console.log('danger', "Error " + err.status, err);
            });
        };
        /**
         * Load user profile.
         * Check if user needs to accept license. (first login)
         * Check if user needs to complete his/her profile.
         * Check if he/she needs to change password.
         */
        $scope.loadUserProfile = function () {
            smartorgApi.getUserProfile().then(function (user) {
                // license
                $scope.flow.needValidation =
                    !user.license || !user.license.accepted;
                $scope.loadLicenseInfo();
                // user profile
                // Skip profile check
                $scope.flow.states.profile = false;
                // if (!user.name || !user.email) {
                //     $scope.flow.states.profile = true;
                //     $scope.$broadcast('user:MY_PROFILE', {
                //         security: false
                //     });
                // }
                // force change password
                if (user.admin && user.admin.force_password_change) {
                    $scope.flow.states.password = true;
                }
                if (!user.browserWarningIgnore && !$scope.isBrowserChrome() && !$scope.isBrowserSafari() && !$scope.isBrowserEdge()) {
                    $scope.flow.states.browser = true;
                }
                $scope.loaded.profile = true;
                $timeout();
            })["catch"](function (err) {
                console.log('danger', 'Error' + err.status, err);
            });
        };
        /**
         * Handle accept or deny legal message.
         *
         * @param type {string} LICENSE or SECURITY_WARNING_WB.
         * @param result {string} Can be accepted or declined.
         * @param message {string} Anything.
         */
        $scope.legalMessageCallback = function (type, result, message) {
            if (result === 'accepted') {
                smartorgApi.acceptWelcomeMessage(type).then(function () {
                    if (type === 'LICENSE') {
                        $scope.flow.states.license = false;
                        // security warning
                        $scope.loadSecurityWarning();
                    }
                    else if (type === 'SECURITY_WARNING_WB') {
                        $scope.flow.states.warning = false;
                        $scope.check();
                    }
                    $timeout();
                })["catch"](function (err) {
                    console.log('danger', 'Error' + err.status, err + message);
                });
            }
            else {
                smartorgApi.protocols.logout();
                $location.path("/login");
                $timeout();
            }
        };
        /**
         * Handle what to do after user saving profile.
         */
        // $scope.profileCallback = () => {
        //     $scope.flow.states.profile = false;
        //     $scope.check();
        // };
        /**
         * Handle password change.
         *
         * @param oldPsw {string} Placeholder, no use.
         * @param newPsw {string} New password.
         */
        $scope.changePassword = function (oldPsw, newPsw) {
            smartorgApi.changePasswordWithoutOld(newPsw).then(function (rs) {
                if (rs.status === 0) {
                    smartorgApi.authenticateThroughToken().then(function (userInfo) {
                        $scope.userName = userInfo.username;
                        $scope.isAdmin = userInfo.is_admin;
                        smartorgApi.protocols.credentials = {
                            username: userInfo.username,
                            isAdmin: userInfo.is_admin
                        };
                        $scope.flow.states.password = false;
                        $scope.check();
                    })["catch"](function (err) {
                        $scope.$broadcast('password:save_feedback', {
                            status: 1,
                            message: err.message
                        });
                    });
                }
                else {
                    $scope.$broadcast('password:save_feedback', {
                        status: 1,
                        message: rs.messages.join()
                    });
                }
            })["catch"](function (err) {
                $scope.$broadcast('password:save_feedback', {
                    status: 1,
                    message: err.message
                });
            });
        };
        /**
         * Cancel password change, back to login page.
         */
        $scope.cancelPasswordChange = function () {
            $location.path("/login");
            $timeout();
        };
        /**
         * Check browser.
         */
        $scope.isBrowserChrome = function () {
            var currentBrowser = smartorg_1.get_browser_info().name || 'your current using browser';
            $scope.currentBrowser = currentBrowser;
            return currentBrowser.toLocaleLowerCase() === 'chrome';
        };
        $scope.isBrowserSafari = function () {
            var currentBrowser = smartorg_1.get_browser_info().name || 'your current using browser';
            $scope.currentBrowser = currentBrowser;
            return currentBrowser.toLocaleLowerCase() === 'safari';
        };
        $scope.isBrowserEdge = function () {
            var currentBrowser = smartorg_1.get_browser_info().name || 'your current using browser';
            $scope.currentBrowser = currentBrowser;
            var browserNameLower = currentBrowser.toLocaleLowerCase();
            return browserNameLower === 'edge' || browserNameLower === 'msedge';
        };
        $scope.saveUserBrowserSetting = function () {
            if ($scope.ignoreBrowser) {
                smartorgApi.ignoreUserBrowserWarning().then(function (res) {
                    console.log('success', 'Success' + res.status, res.message);
                })["catch"](function (err) {
                    console.log('danger', 'Error' + err.status, err.message);
                });
            }
            $scope.flow.states.browser = false;
            $scope.check();
        };
        $scope.cancelBrowserSetting = function () {
            $scope.flow.states.browser = false;
            $scope.check();
        };
        /**
         * Watch the loading of 3 different page. Only proceed when
         * everything is loaded.
         */
        $scope.$watch('[loaded.profile, loaded.license, loaded.warning]', function () {
            $scope.check();
        });
        /**
         * Check if everything is done.
         */
        $scope.check = function () {
            var o = $scope.loaded;
            var t = $scope.flow.states;
            if (o.profile && o.license && o.warning && !t.license && !t.warning && !t.profile && !t.password && !t.browser) {
                // if (o.profile && o.license && o.warning && o.browser && !t.license && !t.warning && !t.profile && !t.password && !t.browser) {
                $scope.loggedIn();
            }
        };
        /**
         * What ot do after successfully checking.
         */
        $scope.loggedIn = function () {
            // Should check if needs to go into first page.
            // if (window.innerWidth > 1024) {
            //     $location.path("/workbench-3");
            // } else {
            //     $location.path("/workbench-2");
            // }
            $location.path("/workbench");
            $timeout();
        };
        smartorgApi.authenticateThroughToken().then(function (userInfo) {
            $scope.userName = userInfo.username;
            $scope.isAdmin = userInfo.is_admin;
            smartorgApi.protocols.credentials = {
                username: userInfo.username,
                isAdmin: userInfo.is_admin
            };
            $scope.loadUserProfile();
            // $scope.checkBrowser();
        })["catch"](function (err) {
            console.error(err);
            $location.path('/login');
        });
    }
]);
module.exports = 'smartorg.r6.views.firstpage';
//# sourceMappingURL=firstpage.js.map


// WEBPACK FOOTER //
// ./app/views/firstpage/app/js/plumbing/firstpage.js